import { MONTHS_FULL } from '../../../constants';
import { isoWeek } from '../../../utils/dates';

// Groupes de mois de la fenêtre (libellé + nombre de colonnes).
export function monthGroups(days) {
  const groups = [];
  let cur = null;
  for (const day of days) {
    const mk = `${day.d.getFullYear()}-${day.d.getMonth()}`;
    if (!cur || cur.key !== mk) {
      cur = { key: mk, label: MONTHS_FULL[day.d.getMonth()] + ' ' + day.d.getFullYear(), count: 0 };
      groups.push(cur);
    }
    cur.count++;
  }
  return groups;
}

// Groupes de semaines (pour l'en-tête en zoom semaine/mois) : numéro ISO, étendue en colonnes
export function weekGroups(days) {
  const groups = [];
  let cw = null;
  for (const day of days) {
    const wk = isoWeek(day.d);
    const key = `${day.d.getFullYear()}-W${wk}`;
    if (!cw || cw.key !== key) {
      cw = { key, week: wk, count: 0 };
      groups.push(cw);
    }
    cw.count++;
  }
  return groups;
}

// Période affichée : « Septembre 2026 », « Sep – Nov 2026 » ou « Déc 2026 – Fév 2027 ».
export function periodLabel(days) {
  const first = days[0],
    last = days[days.length - 1];
  if (!first || !last) return '';
  const month = (d) => MONTHS_FULL[d.d.getMonth()];
  const year = (d) => d.d.getFullYear();
  if (first.d.getMonth() === last.d.getMonth() && year(first) === year(last))
    return `${month(first)} ${year(first)}`;
  if (year(first) === year(last))
    return `${month(first).slice(0, 3)} – ${month(last).slice(0, 3)} ${year(last)}`;
  return `${month(first).slice(0, 3)} ${year(first)} – ${month(last).slice(0, 3)} ${year(last)}`;
}
